import { render } from "./NotificationIndicator.vue?vue&type=template&id=27bc9858"
import script from "./NotificationIndicator.vue?vue&type=script&lang=js"
export * from "./NotificationIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__